

import React, { useRef, useState, useContext } from 'react';
import { Button } from 'primereact/button';
import { Tag } from 'primereact/tag';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { classNames } from 'primereact/utils';
import { Checkbox } from 'primereact/checkbox';
import { ColorPicker } from 'primereact/colorpicker';

import axios from '../axios';
import { useFormik } from 'formik';
import AppContext from '../Context/AppContext';
import Modal from '../Widgets/Modal';
import { InputTextarea } from 'primereact/inputtextarea';
import { Dropdown } from 'primereact/dropdown';
import { useMountEffect } from 'primereact/hooks';
import { InputNumber } from 'primereact/inputnumber';

const UserAddModal = ({ hide, update }) => {
    const existingNames = useRef([])
    const { sendMessage, toast, setBlocked } = useContext(AppContext)

    const [visible, setVisible] = useState(true)

    const formik = useFormik({
        initialValues: {
            user: "",
            password: "",
            permissions: 0,
        },
        validate: (data) => {
            let errors = {};
            if (!data.user) {
                errors.user = 'User is required';
            }
            else if (data.user.length < 2) {
                errors.user = 'User must have at least 2 letters'
            }
            else if (data.user.length > 15) {
                errors.user = 'User must be not longer than 15 letters'
            }
            else if (existingNames.current.some(item => item.toLowerCase() === data.user.toLowerCase())) {
                errors.user = 'User already exists in the database'
            }

            return errors;
        },
        onSubmit: async (data) => {
            setBlocked(true)
            try {
                const response = await axios.get('/users/check', { params: { user: data.user } });
                if (response.data.success) {
                    existingNames.current = [...existingNames.current, ...response.data.data]
                    formik.validateForm()
                    setBlocked(false)
                    return
                }
            }
            catch (error) {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to connect!', life: 3000 });
                setBlocked(false)
                return
            }

            try {
                const response = await axios.post('/users/add', data);
                if (response.data.success) {
                    toast.current.show({ severity: 'success', summary: 'Successful', detail: `User ${data.user} added!`, life: 3000 });
                }
                else {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to add user!', life: 3000 });
                }
            }
            catch (error) {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to add user!', life: 3000 });
            }

            setBlocked(false)
            update()
            sendMessage(JSON.stringify({ type: "users_added" }))
            setVisible(false)
        }
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    const footer = (
        <React.Fragment>
            <Button label="Cancel" icon="pi pi-times" outlined onClick={() => { setVisible(false) }} />
            <Button label="Save" icon="pi pi-check" className="m-0" type='submit' form='submit-user' />
        </React.Fragment>
    );

    return (
        <Modal header="Add User" visible={visible} onHide={() => setVisible(false)} transitionOptions={{ onExited: () => hide() }} footer={footer}>
            <form onSubmit={formik.handleSubmit} id='submit-user' className='formgrid grid'>
                <div className="field col-12">
                    <label htmlFor="user">User</label>
                    <InputText name='user' id='user' value={formik.values.user} onChange={formik.handleChange} className={classNames('w-full', { 'p-invalid': isFormFieldValid('user') })} autoFocus />
                    {getFormErrorMessage('user')}
                </div>

                <div className="field col-12">
                    <label htmlFor="password">Password</label>
                    <Password name='password' inputId='password' value={formik.values.password} onChange={formik.handleChange} toggleMask className={classNames('w-full', { 'p-invalid': isFormFieldValid('password') })} inputClassName='w-full' feedback={false} />
                    {getFormErrorMessage('password')}
                </div>

                <div className="field col-12 mb-1">
                    <label>Permissions</label>
                </div>
                <div className="field col-12">
                    <div className="flex align-items-center">
                        <Checkbox name="permissions" inputId="permissions" checked={formik.values.permissions} onChange={formik.handleChange} />
                        <label htmlFor="permissions" className="ml-2">Admin</label>
                    </div>
                </div>
            </form>
        </Modal>
    );
}

export default UserAddModal;